import { ChangeDetectionStrategy, Component, effect, inject, input, ViewEncapsulation, Injector } from '@angular/core';
import { FiInfiniteScrollDataSource } from '@fi-shared/fi-items-list/fi-infinite-scroll-data-source';
import { IOnboardingReportParticipant } from '@fi-app/fi-onboarding/fi-onboarding-report/fi-onboarding-report';
import { FiItemsListType } from '@fi-shared/fi-items-list/fi-items-list-type';
import { ObjectTypes } from '@fi-shared/types';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

@Component({
    selector: 'fi-onboarding-report-participants-widget-table',
    templateUrl: './fi-onboarding-report-participants-widget-table.component.html',
    styleUrl: './fi-onboarding-report-participants-widget-table.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-onboarding-report-participants-widget-table' },
    standalone: false,
})
export class FiOnboardingReportParticipantsWidgetTableComponent extends FiInfiniteScrollDataSource<IOnboardingReportParticipant> {
    public onboardingParticipants = input.required<IOnboardingReportParticipant[]>();
    private _onboardingParticipantsChangeEffect = effect(() => {
        const onboardingParticipants = this.onboardingParticipants();
        this.reloadData();
    });
    public widgetId = input.required<number>();

    public readonly itemsListType = FiItemsListType.OnboardingReportParticipants;
    public readonly objectType = ObjectTypes.OnboardingReport;
    protected readonly defaultSortColumnName = 'CompletedFraction';

    private readonly fiStateService = inject(FiStateService);

    protected readonly circleFillColor = '#2196F3';
    protected readonly circleSize = 36;
    protected readonly circleStrokeWidth = 4;
    protected readonly circleAnimationDuration = 200;
    protected readonly circleFillDirection = 'right';
    protected readonly circleFullFillLightColor = '#29CC6A';
    protected readonly circleFullFillDarkColor = '#18C45D';

    protected getRowClassFn = (item: IOnboardingReportParticipant): string => 'cursor-pointer';

    constructor(injector: Injector) {
        super(injector);
    }

    public getListData(): Promise<IOnboardingReportParticipant[]> {
        return Promise.resolve(this.onboardingParticipants());
    }

    // protected getItemCompletionPercentage(item: IOnboardingReportParticipant): number {
    //     return Math.round((item.CompletedStepsCount / item.TotalStepsCount) * 100);
    // }

    protected getCompletedStatusText(item: IOnboardingReportParticipant): string {
        return `${item.CompletedStepsCount}/${item.TotalStepsCount}`;
    }

    protected onRowClick(item: IOnboardingReportParticipant): void {
        this.fiStateService.go(FiStateNames.Onboarding.Report.Widget.ParticipantDetails._name, {
            id: this.widgetId(),
            userId: item.Id,
            onboardingId: item.OnboardingId,
            //businessUnitId: item.BusinessUnitId,
        });
    }
}
